<template>
    <div class="submitlist">
        <router-view></router-view>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'submitlist',
    data: function () {
        return {
            
        }
    },
    computed: {
      ...mapGetters(['getUserInfo'])
    },
    created () {
      // this.checkInfo()
    },
    methods: {
      checkInfo () {
        if(this.getUserInfo.volunteer_info == 0) {
          this.$router.push('/pcpage/userinfo')
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
